import { render } from "./InDeveloping.vue?vue&type=template&id=3c9f26a8&scoped=true&ts=true"
import script from "./InDeveloping.vue?vue&type=script&lang=ts"
export * from "./InDeveloping.vue?vue&type=script&lang=ts"

import "./InDeveloping.vue?vue&type=style&index=0&id=3c9f26a8&scoped=true&lang=css"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9f26a8"]])

export default __exports__